import React, { useState } from "react";
import { formatCurrency } from "../utils/formatters";

const PAGE_SIZE = 24;

const AmortizationTable = ({ schedule, rateType, interestRate }) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(schedule.length / PAGE_SIZE);
  const pageRows = schedule.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="table-section">
      <h2 className="section-heading gradient-title">📋 Amortization Schedule</h2>

      <div className="table-container">
        <table className="schedule-table" aria-label="Loan amortization schedule">
          <thead>
            <tr>
              <th scope="col">#</th>
              {rateType === "floating" && <th scope="col">Rate</th>}
              <th scope="col">EMI</th>
              <th scope="col">Principal</th>
              <th scope="col">Interest</th>
              <th scope="col">Extra</th>
              <th scope="col">Lumpsum</th>
              <th scope="col">Balance</th>
            </tr>
          </thead>
          <tbody>
            {pageRows.map((row) => (
              <tr
                key={row.month}
                className={
                  row.lumpsumPrepayment > 0 || row.extraPayment > 0
                    ? "highlight"
                    : row.rateChanged
                    ? "rate-changed"
                    : ""
                }
              >
                <td style={{ fontWeight: 600, color: "var(--gray-400)" }}>{row.month}</td>
                {rateType === "floating" && (
                  <td style={{
                    color: row.rateChanged ? "var(--warning)" : "var(--gray-700)",
                    fontWeight: row.rateChanged ? 700 : 400,
                  }}>
                    {(row.rate ?? interestRate).toFixed(2)}%
                  </td>
                )}
                <td style={{ fontWeight: 600 }}>{formatCurrency(row.emi)}</td>
                <td style={{ color: "var(--primary)" }}>{formatCurrency(row.principal)}</td>
                <td style={{ color: "var(--danger)" }}>{formatCurrency(row.interest)}</td>
                <td className="extra-payment">{formatCurrency(row.extraPayment)}</td>
                <td className="lumpsum-payment">{formatCurrency(row.lumpsumPrepayment)}</td>
                <td style={{ fontWeight: 600 }}>{formatCurrency(row.balance)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            className="pagination-btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
            aria-label="Previous page"
          >
            ← Prev
          </button>
          <span className="pagination-info">
            Page {page} / {totalPages} &nbsp;·&nbsp; {schedule.length} months total
          </span>
          <button
            className="pagination-btn"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            aria-label="Next page"
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default AmortizationTable;
